function employeeReadinessClassification(employee) {
  if (employee.pendingApproval) return 'pending';
  if (employee.blockedEinsatzorte && employee.blockedEinsatzorte.length) return 'blocked';
  if (employee.einsatzfaehig) return 'normal';
  if (employee.einsatzbereitManuell) return 'manual';
  return 'unavailable';
}

function employeeReadinessTooltip(employee) {
  const classification = employeeReadinessClassification(employee);
  if (classification === 'pending') return 'Freigabe durch internen Admin ausstehend';
  if (classification === 'blocked') {
    return 'Gesperrt für: ' + employee.blockedEinsatzorte.join(', ');
  }
  if (classification === 'manual') return 'Nur manuell einsatzbereit';
  if (classification === 'unavailable') return 'Nicht einsatzfähig';
  return '';
}

module.exports = {
  employeeReadinessClassification,
  employeeReadinessTooltip
};
